// Includes
import Vue from 'vue';
import NProgress from 'nprogress';
import VueRouter from 'vue-router';
// Notify to vue to use vue-router
Vue.use(VueRouter);
// Define dashboard routes
const routes = [
    {path: '/utm', component: require('./views/UtmGen').default},
];

// Set the routes in vue-router
const router = new VueRouter({
    routes,
    linkActiveClass: "active",
    mode: "history"
});


router.afterEach((to, from) => {
    NProgress.done();
});

// Export router
export default router;
